import { RootObject } from '../../types/InAppDonationTypes/comcastDonationTypes'
import { SubscriptionDataPayload } from '../../types/InAppDonationTypes/subscriptionDonationTypes'

const subscription: RootObject<SubscriptionDataPayload> = {
  data: {
    type: 'Subscription',
    attributes: {
      token: '',
      amount: null,
      gateway_type: 'xfinity',
      source_codes: ['xfinity test'],
      months: 2,
      pid: '',
      gateway_transaction_request: [],
    },
    relationships: {
      customer: {
        data: {
          type: 'Customer',
          first_name: '',
          last_name: '',
          gateway_customer_id: '',
          email: '',
        },
      },
      payment_campaign: {
        data: {
          id: '',
          type: 'PaymentCampaign',
        },
      },
    },
  },
}

export default subscription
